import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { listAllBuildEmployer } from "../../actions/employerAction";
import { listBuildApplyDev } from "../../actions/developerAction";
import DevWelcome from "../../components/DevWelcome";
import Message from "../../components/Message";
import DevMenu from "../../components/DevMenu";
import RightDash from "../../components/RightDash";
import Login from "../Login";
import { truncateString } from "../../helpers";
import Signout from "../../components/Signout";
import "../../styles/dashboard.css";

const DeveloperApplied = ({ history, resizeMenu, setResizeMenu }) => {
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  const listBuildApply = useSelector((state) => state.listBuildApply);

  const { applied, loading, error } = listBuildApply;

  useEffect(() => {
    dispatch(listBuildApplyDev());
  }, [listBuildApplyDev]);

  if (!userInfo) {
    return <Login />;
  }

  if (userInfo && userInfo.role === "employer") {
    history.push("/employer/dashboard");
  }

  return (
    <div className="dashboard">
      <DevMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">
            {error} <a href="/developer/jobs">refresh page</a>
          </Message>
        ) : (
          <div className="right-wrapper">
            <DevWelcome />
            <div className="main p-3">
              <div className="my-2 mx-25">
                <h4 className="font-normal mb-25">Applications</h4>
                <div className="overflow-x">
                  <div>
                    {applied && applied.length === 0 && (
                      <div>You've not applied for any job</div>
                    )}
                    {applied &&
                      applied.slice(0, 5).map((applied) => (
                        <div
                          key={applied._id}
                          className="d-flex justify-content-between align-items-center table shadow-sm border mb-1 px-1 py-50">
                          <div>
                            <div>
                              <span className="date">
                                {applied.createdAt.slice(0, 10)}
                              </span>
                            </div>
                            <div className="title">
                              <Link
                                to={`/developer/dashboard/job/${applied.build._id}`}>
                                {" "}
                                {applied.build.title}
                              </Link>
                            </div>
                          </div>
                          <div className="text-right">
                            <div className="font-weight-bolder">skill</div>
                            <div className="status">
                              {applied.build && applied.build.skill.join(", ")}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default DeveloperApplied;
